import React from 'react';
import ShadowContainer from './ShadowContainer';
import Button from './Button';
import Highlight from './Highlight';

const WebSystem = () => (
  <div style={styles.webSystemSection}>
    <div style={styles.textWrapper}>
      <Highlight width={619} height={400} />
      <div style={styles.textBox}>
        <h2 style={styles.heading}>
          Desktop web sistem za prodavce
        </h2>
        <p style={styles.subtext}>
          Ovde ide tekst o desktop platformi
        </p>
        <Button
  width={310} 
  height={80} 
  borderColor="yellow" 
  backgroundColor="#96C0FF" 
  text="Postani partner" 
/>
      </div>
    </div>
   {/* <ShadowContainer Image={HomePage} width={640} height={672}   imageStyle={{ objectPosition: 'top'}} 
 />*/}
  </div>
);

export default WebSystem;


const styles = {
  webSystemSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(23, 23, 24)',
    padding: 40,
    gap: 70,
    flexWrap: 'wrap',
    position: 'relative',
    marginTop: 120,
    marginBottom: '100px'
  },
  textWrapper: {
    position: 'relative',
    width: 619,
    height: 400,
    zIndex: 0,
  },
  textBox: {
    position: 'relative',
    backgroundImage: 'linear-gradient(232deg, rgba(153, 153, 153, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%)',
    padding: 20,
    borderRadius: 12,
    width: '100%',
    height: '100%',
    zIndex: 2,
    backdropFilter: 'blur(6px)',
  },
  heading: {
    fontSize: '48px',
    fontWeight: 700,
    backgroundImage: 'linear-gradient(235.42deg, #EEFF00 0%, #B6BB6C 100%)',
    backgroundClip: 'text',
    color: 'transparent',
    marginBottom: 16,
    lineHeight: '64px',
  },
  subtext: {
    fontSize: 16,
    color: '#ffffff',
    lineHeight: '24px',
    marginBottom: 24,
  },
  

};
